import React from 'react';
import { getLang, setLang } from '../i18n';

// Tombol ganti bahasa ID ⇄ EN (2026-10-24). data-no-translate: labelnya sendiri jangan ikut diterjemahkan.
export default function LangToggle({ style, floating }) {
  const en = getLang() === 'en';
  // Di HP tombol mengambang bisa menutupi tombol lain — sembunyikan kecuali mode English sedang aktif.
  if (floating && !en && typeof window !== 'undefined' && window.innerWidth < 768) return null;
  return (
    <button type="button" data-no-translate onClick={() => setLang(en ? 'id' : 'en')}
      title={en ? 'Ganti ke Bahasa Indonesia' : 'Switch to English'}
      style={{ fontSize: 12, fontWeight: 600, padding: '6px 10px', borderRadius: 8, border: '1px solid rgba(127,127,127,0.35)', background: floating ? '#ffffff' : 'transparent', color: floating ? '#111827' : 'inherit', cursor: 'pointer',
        ...(floating ? { position: 'fixed', right: 16, bottom: 16, zIndex: 9000, boxShadow: '0 4px 14px rgba(0,0,0,0.15)' } : {}), ...style }}>
      🌐 {en ? 'EN' : 'ID'} → {en ? 'ID' : 'EN'}
    </button>
  );
}
